import { createPortal } from 'react-dom';
import React, { Fragment, useEffect, useState, useRef } from 'react';
import { withStyles, Grid } from '@material-ui/core';
import Modal from './Modal';
import Error from '../../asset/img/icon_error.svg';
import Close from '../../asset/img/icon_close.svg';

const styles = (theme) => ({
  root: {
    display: 'flex',
  },
  drawerHeaderClose: {
    position: 'fixed',
    height: '3.063rem',
    background: '#fff',
    width: '100%',
    zIndex: '1',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0.625rem 1rem',
  },
  closeContainer: {
    display: 'flex',
    minHeight: 'auto',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0.625rem 1rem',
  },
  modalTitle: {
    color: '#000',
    padding: '1px 0px',
    fontSize: '1.125rem',
    fontStyle: 'normal',
    textAlign: 'left',
    fontFamily: 'inherit',
    fontWeight: 'bold',
    lineHeight: '1.33',
    fontStretch: 'normal',
    letterSpacing: 'normal',
  },
  modalContainer: {
    width: '100%',
    position: 'fixed',
    zIndex: '1300',
    inset: '0',
    overflowY: 'auto',
  },
  modalGridContainer: {
    backgroundColor: '#f6f6f6',
    fontSize: theme.font.size13,

    '& .layerPopupTop': {
      display: 'none',
    },
    '& .layerPopupCon': {},
    '& .type2.contentsLyrPopx': {
      display: 'none',
    },
    '& .layerTopBtn': {
      display: 'none',
    },
  },
  termContent: {
    lineHeight: '1.43',
    padding: '3px 16px',
    paddingTop: '3.75rem',
    marginBottom: '120px',
    '& dd': {
      marginInlineStart: '0px',
    },
    '& ol': {
      listStyleType: 'none',
      paddingInlineStart: '0px',
    },
    '& li': {
      listStyleType: 'none',
      paddingInlineStart: '10px',
    },
    '& ul': {
      paddingInlineStart: '10px',
    },
    '& dt': {
      fontWeight: 'bold',
    },
  },
  modalFooter: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '14px 16px 36px 16px',
    // marginTop: "16px",
    placeContent: 'center',
    borderTop: '1px solid #ddd',
    height: '100px',
    backgroundColor: '#fff',
    position: 'fixed',
    bottom: 0,
  },
  modalButton: {
    width: '100%',
    height: '50px',
    borderRadius: '6px',
    border: 'solid 1px #ddd',
    backgroundColor: '#fff',
    // margin: "0px 4px",
    fontFamily: 'NotoSansKR',
    fontSize: '14px',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.43',
    letterSpacing: 'normal',
    textAlign: 'center',
    color: '#000',
  },
  modalButtonDefault: {
    color: '#bbb',
    backgroundColor: '#999',
    border: '0px',
  },
  modalButtonStrong: {
    color: '#fff',
    backgroundColor: '#ea1917', //"#da0f47",
    border: '0px',
    fontWeight: 'bold',
  },
  modalButtonLeft: {
    paddingRight: '4px',
  },
  modalButtonRight: {
    paddingLeft: '4px',
  },
  close: {
    border: 'none',
    backgroundColor: 'transparent',
  },
});

function Terms3(props) {
  const { classes, data, modalOpen, modalClose, checkOk } = props;
  const [text, setText] = useState('');
  const modalRef = useRef();

  useEffect(() => {
    (async () => {
      let response = await fetch('/ext/reservation/html/terms/terms_3_kr.html');
      let term_text = await response.text();
      setText(term_text);
    })();
  }, []);

  useEffect(() => {
    if (modalOpen) {
      // 웹접근성 - 모달팝업 포커스 25-01
      const { current: modalElement } = modalRef;
      window.setTimeout(() => {
        modalElement.focus();
      });
    }
  }, [modalOpen]);

  const handleOk = (ok) => {
    checkOk(ok);
    modalClose();
  };

  return createPortal(
    <div className={classes.root}>
      {/* <Modal
        component={withStyles(styles)(TermContent)}
        anchor="bottom"
        title="개인정보 수집 및 이용 동의"
        titleDivider={false}
        titleClassName={classes.modalTitle}
        data={data}
        modalOpen={modalOpen}
        modalClose={modalClose}
        height="100%"
        borderRadius="0px"
        closeType="close"
      /> */}
      {modalOpen && (
        <div className={classes.modalContainer}>
          <div className={classes.drawerHeaderClose}>
            <div className={classes.modalTitle} ref={modalRef} tabIndex="0">
              개인정보 수집 및 이용 동의
            </div>
            <button className={classes.close}>
              <img
                src={Close}
                className={classes.arrowDown}
                onClick={modalClose}
                alt="닫기"
              />
            </button>
          </div>
          <Fragment>
            <Grid container className={classes.modalGridContainer}>
              <div
                className={classes.termContent}
                dangerouslySetInnerHTML={{ __html: text }}
              />
            </Grid>
            {/* footer button */}
            <Grid container className={classes.modalFooter}>
              <Grid item xs={6} className={classes.modalButtonLeft}>
                <button className={classes.modalButton} onClick={() => handleOk(false)}>
                  동의안함
                </button>
              </Grid>
              <Grid item xs={6} className={classes.modalButtonRight}>
                <button
                  className={[classes.modalButton, classes.modalButtonStrong].join(' ')}
                  onClick={() => handleOk(true)}
                >
                  동의
                </button>
              </Grid>
            </Grid>
            {/* <div className={classes.modalFooter}>
        <button className={classes.modalButton}>취소</button>
        <button className={[classes.modalButton, classes.modalButtonDefault].join(" ")}>확인</button>
      </div> */}
          </Fragment>
        </div>
      )}
    </div>,
    document.getElementById('terms')
  );
}
export default withStyles(styles)(Terms3);
